import AuthorizedCreditCreditLimitUntil from '@/generated/controls/authorizedCredit/AuthorizedCreditCreditLimitUntil.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: AuthorizedCreditCreditLimitUntil
})
